import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Col, Form, Row, Button, Spinner } from 'react-bootstrap';
import Moment from "moment";
import { toast } from 'react-toastify';
import { clientListAPI } from 'actions/ClientRegistration/ClientRegistrationAction';
import { getClientCaseMasterListAPI } from 'actions/CaseNextDate/caseNextDateAction';
import { courtMasterListAPI } from 'actions/CourtMaster/courtMasterAction';
import { generatePendingActionReportPdfAPI, pendingActionReportDataAction } from 'actions/PendingActionReport/pendingActionReportAction';
import loader from '../../assets/img/loader.svg'

export const PendingActionReportDetail = () => {
	const dispatch = useDispatch();
	const [isLoading, setIsLoading] = useState(false);
	const [clientList, setClientList] = useState([]);
	const [clientCaseMasterList, setClientCaseMasterList] = useState([]);
	const [courtMasterList, setCourtMasterList] = useState([]);
	const selectedClientCode = localStorage.getItem('ClientCode');

	let token = localStorage.getItem('Token') || sessionStorage.getItem('Token');
	const headers = {
		Authorization: `Bearer ${JSON.parse(token).value}`
	};

	const pendingActionReportReducer = useSelector((state) => state.rootReducer.pendingActionReportReducer)
	var pendingActionReportData = pendingActionReportReducer.pendingActionReportData;

	useEffect(() => {
		getCourtMasterList();
	}, [])

	useEffect(() => {
		if (clientList.length <= 0) {
			getClientList();
		}

	}, [])
	useEffect(() => {
			  setTimeout(() => {
				setIsLoading(false);
			  }, 1000);
	}, [isLoading])

	const getClientList = async () => {
		const data = {
			pageNumber: 1,
			pageSize: 1,
			SearchText: '',
			EncryptedAdvocateCode: localStorage.getItem('EncryptedAdvocateCode'),
			isDropDown: true
		};

		dispatch(
			clientListAPI(
				data,
				res => {
					let clientData = [];

					if (res.data.data.clientList.length > 0)
						res.data.data.clientList.forEach(client => {
							clientData.push({
								key: client.clientName,
								value: client.clientCode
							});
						});
					setClientList(clientData);
				},
				err => {
					setClientList([]);
					console.log(err?.data.message);
				},
				headers
			)
		);
	};

	const getClientCaseMasterList = async (clientCode) => {
		const data = {
			EncryptedAdvocateCode: localStorage.getItem('EncryptedAdvocateCode'),
			ClientCode: clientCode ? clientCode : selectedClientCode
		};
		await dispatch(
			getClientCaseMasterListAPI(
				data,
				res => {
					let caseMasterData = [];
					if (res.data && res.data.data.caseMasterList.length > 0) {
						res.data.data.caseMasterList.forEach(data => {
							caseMasterData.push({
								key: `${data.caseNo} --- ${data.caseTitle}`,
								value: { clientCaseNo: data.caseNo, courtCode: data.courtCode },
							});

						});
						setClientCaseMasterList(caseMasterData);
					} else {
						setClientCaseMasterList([]);
					}
				},
				err => {
					setClientCaseMasterList([]);
				},
				headers
			)
		);
	};

	const getCourtMasterList = async () => {
		const data = {
			IsCaseSchedule: true
		}
		await dispatch(courtMasterListAPI(
			data,
			res => {
				let courtData = [];
				if (res.data && res.data.data.courtList.length > 0) {
					res.data.data.courtList.forEach(data => {
						courtData.push({
							key: data.courtName,
							value: data.courtCode
						});
					});
					setCourtMasterList(courtData);
				} else {
					setCourtMasterList([]);
				}
			},
			(err) => {
				setCourtMasterList([]);
			},
			headers
		));
	};

	const GeneratePDFCaseSchedule = async () => {
		let requestData = {
			EncryptedAdvocateCode: localStorage.getItem("EncryptedAdvocateCode"),
			ClientCode: localStorage.getItem("ClientCode") ? localStorage.getItem("ClientCode") : pendingActionReportData.clientCode ? pendingActionReportData.clientCode : "",
			FromDate: pendingActionReportData.fromDate ? Moment(pendingActionReportData.fromDate).format("YYYY-MM-DD") : Moment().format("YYYY-MM-DD"),
			ToDate: pendingActionReportData.toDate ? Moment(pendingActionReportData.toDate).format("YYYY-MM-DD") : Moment().format("YYYY-MM-DD"),
			CaseNo: localStorage.getItem("ClientCaseNo") ? localStorage.getItem("ClientCaseNo") : pendingActionReportData.clientCaseNo ? pendingActionReportData.clientCaseNo : "",
			Status: pendingActionReportData.status ? pendingActionReportData.status : "O",
			CourtCode: localStorage.getItem('CourtCode') ? localStorage.getItem('CourtCode') : pendingActionReportData.courtCode ? pendingActionReportData.courtCode : "",
		}
			setIsLoading(true);
		await dispatch(
			generatePendingActionReportPdfAPI(
				requestData,
				(res) => {
             setIsLoading(false);
					console.log(res);
				},
				(err) => {
					setIsLoading(false);
					toast.error("No records found!", {
						theme: 'colored',
						autoClose: 10000
					});
					console.error("Error occurred while generating PDF:", err?.message || err);
				},
				headers
			)
		);
	}

	const handleFieldChange = (e) => {
		e.target.value;
		if (e.target.name === 'clientCode') {
			dispatch(
				pendingActionReportDataAction({
					...pendingActionReportData,
					clientCode: e.target.value,
					clientCaseNo: null,
				})
			);
			getClientCaseMasterList(e.target.value)
		} else if (e.target.name === 'clientCaseNo') {
			dispatch(
				pendingActionReportDataAction({
					...pendingActionReportData,
					clientCaseNo: e.target.value,
				})
			);

		} else if (e.target.name === 'courtCode') {
			dispatch(
				pendingActionReportDataAction({
					...pendingActionReportData,
					courtCode: e.target.value || '',
				})
			);

		} else {
			dispatch(
				pendingActionReportDataAction({
					...pendingActionReportData,
					[e.target.name]: e.target.value,
				})
			);
		}
	};

	return (
		<>
			{/* {isLoading ? (
				<Spinner
	  className="loader-color popup-loader position-fixed top-50 start-50 translate-middle z-index-5"
          // className="position-absolute start-50 loader-color"
					animation="border"
				/>
			) : null} */}
			      {isLoading ? (
  <img
    src={loader}
    alt="Loading..."
    className="loader-gif position-fixed top-50 start-50 translate-middle z-index-5"
  />
) : null}
			<Form className="details-form PendingActionReport" id="CaseScheduleDetailDashboard">
				<Row className='mb-1 ms-2 justify-content-left '>
					<Form.Label column className='col-auto'>
						From Date
					</Form.Label>
					<Col className='col-auto'>
						<Form.Control type='date' id="dtFromDate" name="fromDate" onChange={(e) => handleFieldChange(e)}
							value={pendingActionReportData.fromDate ? Moment(pendingActionReportData.fromDate).format('YYYY-MM-DD') : Moment().format('YYYY-MM-DD')}
						/>
					</Col>
					<Form.Label column className='col-auto'>
						To Date
					</Form.Label>
					<Col className='col-auto'>
						<Form.Control type='date' id="dtToDate" name="toDate" onChange={(e) => handleFieldChange(e)}
							value={pendingActionReportData.toDate ? Moment(pendingActionReportData.toDate).format('YYYY-MM-DD') : Moment().format('YYYY-MM-DD')}
						/>
					</Col>
					<Form.Label column className='col-auto'>
						Client Name
					</Form.Label>
					<Col className='col-auto'>
						<Form.Select id="txtClientCode" className='' name="clientCode" onChange={(e) => handleFieldChange(e)} value={pendingActionReportData.clientCode || ''}>
							<option value=''>Select</option>
							{clientList.map((option, index) => (
								<option key={index} value={option.value}>{option.key}</option>
							))}
						</Form.Select>
					</Col>
				</Row>
				<Row className='justify-content-left ms-2 casSchedule-button'>
					<Form.Label column className='col-auto'>Court Name</Form.Label>
					<Col className='col-3'>
						<Form.Select id="txtCourtCode" name="courtCode" value={pendingActionReportData.courtCode || ""} onChange={(e) => handleFieldChange(e)}>
							<option value=''>Select</option>
							{courtMasterList.map((option, index) => (
								<option key={index} value={option.value}>{option.key}</option>
							))}
						</Form.Select>
					</Col>
					<Form.Label column className='col-auto'>Case No</Form.Label>
					<Col className="col-2">
						<Form.Select
							id="txtClientCaseNo"
							name="clientCaseNo"
							value={pendingActionReportData.clientCaseNo || ''}
							onChange={(e) => handleFieldChange(e)}>
							<option value="">Select</option>
							{clientCaseMasterList.map((option, index) => (
								<option key={index} value={option.value.clientCaseNo}>
									{option.key}
								</option>
							))}
						</Form.Select>
					</Col>
					<Form.Label column className='col-auto'>Status</Form.Label>
					<Col className='col-3'>
						<Form.Select id="txtStatus" className="statusColumn" name="status" value={pendingActionReportData.status} onChange={(e) => handleFieldChange(e)}	>
							<option selected value="O">Open</option>
							<option value="C">Close</option>
						</Form.Select>
					</Col>
					<Col className='col-auto'>
						<Button className='pending-generate-button'
							onClick={() => GeneratePDFCaseSchedule()}>Generate Report</Button>
					</Col>
				</Row>
			</Form >
		</>
	)
}